import { render } from "./newsInfo.vue?vue&type=template&id=417e1e12&scoped=true"
import script from "./newsInfo.vue?vue&type=script&lang=js"
export * from "./newsInfo.vue?vue&type=script&lang=js"

import "./newsInfo.vue?vue&type=style&index=0&id=417e1e12&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-417e1e12"]])

export default __exports__